import { createSlice } from "@reduxjs/toolkit";
import type { PersonalizationStatus } from "@foundation/personalization";

type Personalization = {
    [key: string]: {
        recommendations: [];
        status: PersonalizationStatus;
        error: unknown;
    };
};

const initialState = {
    personalizationStories: {} as Personalization,
};

const personalizationSlice = createSlice({
    name: "personalizationSlice",
    initialState,
    reducers: {
        setPersonalization(state, action) {
            const { storiesKey, recommendations, status, error } =
                action.payload;
            state.personalizationStories[storiesKey] = {
                recommendations,
                status,
                error,
            };
        },
    },
});

export const { setPersonalization } = personalizationSlice.actions;
export default personalizationSlice.reducer;
